import $ from 'jquery';

const $mobMenuBtn = $('.js-mob-menu');
const $mobMenuLinks = $('.js-mob-links');

if ($mobMenuBtn.length > 0) {
  $mobMenuBtn.on('click tap', (e) => {
    const $this = $(e.currentTarget);
    $this.toggleClass('is-active');
    $mobMenuLinks.toggleClass('is-active');
  });
}



// WEBPACK FOOTER //
// ./js/components/init-menu.js